import { theme } from "../../theme";

export const getBoxStyles = (hasBoxShadow?: boolean) => ({
  borderRadius: "8px",
  backgroundColor: theme.backgrounds.widget,
  boxShadow: hasBoxShadow
    ? theme.boxShadow
    : "none",
});
